import superagentPromise from 'superagent-promise'
import _superagent from 'superagent'

const superagent = superagentPromise(_superagent, global.Promise)

let API_ROOT = process.env.REACT_APP_API_BASE_URL_PROD;
if(process.env.REACT_APP_ENV=='local'){
  API_ROOT = process.env.REACT_APP_API_BASE_URL_LOCAL
}
if(process.env.REACT_APP_ENV=='dev'){
  API_ROOT = process.env.REACT_APP_API_BASE_URL_DEV
}
if(process.env.REACT_APP_ENV=='uat'){
  API_ROOT = process.env.REACT_APP_API_BASE_URL_UAT
}

const encode = encodeURIComponent
const responseBody = res => res.body

var token = null
var refresh = null
const tokenPlugin = req => {
  // console.log('kt Token', token);
  // console.log('kt Refresh', refresh);
  if (window.document.documentMode) {
    req.set('Pragma','no-cache')
  }
  if (token && refresh) { 
    req.set('Authorization', `Token ${token}`)
    req.set('RefreshToken', `Token ${refresh}`)
  }
}

const authPlugin = (req, auth) => {
  if (auth) {
    req.set('Authorization', `Basic ${window.btoa(auth.user.username + ':' + auth.user.password)}`);
  }
}

const requests = {
  auth: (url, auth , body) =>{
    return superagent.post(`${API_ROOT}${url}`, body).use((req) => { return authPlugin(req, auth); }).then(responseBody);
  },
  del: url => superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  get: url => superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  upload: (url, file) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .attach('file', file)
      .then(responseBody),
  download: (url, name, linkRef) => {
    fetch(`${API_ROOT}${url}`, { headers: new Headers(
      { 
        'authorization': `Token ${token}` ,
        'RefreshToken':`Token ${refresh}`, 
      }
    ) }).then(res => {
      if (res.status === '204') {
        // alertService.error('Cert Not Yet Created');
        throw ("No Data Found");
      } else {
        return res.blob();
      }
    }).then(blob => {
      const href = window.URL.createObjectURL(blob);
      const a = linkRef.current;
      a.download = name;
      a.href = href;
      a.click();
      a.href = '';
    }).catch(err => console.error(err));
  }
}

const Auth = {
  current: async () => {
    var data = await requests.get(`/users/auth/user?info=true`);
    if (data["status"] === 200){
      // data.data["token"] = token;
      if ((data['token'] && data['token']!== null) && (data['refreshToken']  && data['refreshToken'] !== null)){
        token = data["token"]
        refresh = data["refreshToken"]
        window.localStorage.setItem('jwt', token);
        window.localStorage.setItem('refresh', refresh);
        // window.localStorage.setItem('updated', new Date().getTime());
      }
    }
    return data;
  },
  // login: (username, password, cert_path, userCert) =>{
  //   let body = { cert_path: cert_path, cert: userCert }
  login: (username, password, userCert) =>{
    let body = { cert: userCert }
    return requests.auth('/auth/login', { user: { username, password } }, body )
  }
}

const cr_company = {
  getUserValue: userValue => requests.get(`/cr_company/apiBuilder/${userValue}`)
}
const ApiBuilder = {
  localSearchResult: ({current, pageSize},query) => {
    const params = utils.encode(query, false, 'query')
    return requests.get(`/api_builder/local/search?current=${current}&size=${pageSize}&${params}`)
  },
  foreignSearchResult: ({current, pageSize},query) => {
    const params = utils.encode(query, false, 'query')
    return requests.get(`/api_builder/foreign/search?current=${current}&size=${pageSize}&${params}`)
  },
  getApiBuilderLimit: () => {
    return requests.get(`/api_builder/api_limit`)
  },
}
const Settings = {
  getSetting: () => {
    return requests.get(`/settings/settings`)
  },
  updateSetting: (data) => {
    return requests.put(`/settings/settings`, data)
  },
}
const Report = {
  getReport: query => {
    var {type, from, to} = query;
    console.log(query);
    var params = `type=${type}`;
    if(from && to){
      params = `${params}&from=${from}&to=${to}`
    }
    // const params = utils.encode(query, false, 'query')
    return requests.get(`/report?${params}`)
  },
}
const Storage = {
  uploadFile: file => requests.upload(`/upload/file`, file)
}

const utils = {
  incapsulateInBrackets: key => {
    return '[' + key + ']'
  },
  encode: (object, isSubEncode = false, prefix = '') => {
    let parts = Object.keys(object).map(key => {
      let encodedParts = []
      if (Array.isArray(object[key])) {
        object[key].map(function (innerKey, index) {
          encodedParts.push(
            utils.encode(
              object[key][index],
              true,
              prefix + key + utils.incapsulateInBrackets(index)
            )
            )
          })
      } else if (object[key] instanceof Object) {
        Object.keys(object[key]).map((innerKey, index) => {
          if (Array.isArray(object[key][innerKey])) {
            encodedParts.push(
              utils.encode(
                object[key][index],
                true,
                prefix +
                utils.incapsulateInBrackets(key) +
                  utils.incapsulateInBrackets(innerKey)
                  )
                  )
          } else {
            encodedParts.push(
              prefix +
              utils.incapsulateInBrackets(key) +
              utils.incapsulateInBrackets(innerKey) +
              '=' +
              encode(object[key][innerKey])
              )
            }
          })
        } else {
        if (isSubEncode) {
          encodedParts.push(
            prefix + utils.incapsulateInBrackets(key) + '=' + object[key]
          )
        } else {
          encodedParts.push(key + '=' + object[key])
        }
      }

      return encodedParts.join('&')
    })

    return parts.join('&')
  }
}

const User = {
  create: ({ username, password, email, current_user, role }) => {
    var payload = {
      username:username,
      password:password,
      email:email,
      role:role ,
      modified_by:current_user
    }
    return requests.post(`/users/create`,payload);
    // return User.readAll();
  },
  update: (uuid, payload) => {
    return requests.put(`/users/update/${uuid}`, payload);
    // return new Promise( (resolve, reject)=>{
    //   setTimeout(async ()=>{
    //     var data = await User.readAll();
    //     resolve(data);
    //   },400);

    // });
  },
  delete: (uuid) => {
    return requests.del(`/users/${uuid}`); //return User.readAll();
  },
  readAll: () =>{   
    return requests.get(`/users/all`)
  },
  readOne: (uuid) =>
    requests.get(`/users/${uuid}`),
  };
  
const TwoFactor = {
  createCert: (uuid)=>{  
    return requests.post(`/2FA/generateKeyPair`, {uuid:uuid})
  },
  downloadCert: (uuid, linkRef)=>{  
    return requests.download(`/2FA/downloadPrivateKey/${uuid}`, 'privateKey.key', linkRef)
  },
  updateCert: (uuid, payload) => {
    return requests.put(`/2FA/changeTwoFactor/${uuid}`, payload);
  },
  uploadCert: (file) =>
    requests.upload(`/upload/uploadCert`, file)
}
  
export default {
  Auth,
  ApiBuilder,
  Report,
  cr_company,
  Storage,
  User,
  Settings,
  TwoFactor,
  setToken: (_token, _refresh) => {
    token = _token
    refresh = _refresh
  },
  getToken: () => {
    let _token = token
    let _refresh = refresh
    return { token: _token, refresh: _refresh }
  },
  ...[{ key: 'cr_no', operator: 'equal', value: '' }]
}



// WEBPACK FOOTER //
// src/agent.js